import faviconDefaultPng from "images/favicon.png";
import faviconDefaultIco from "images/favicon.ico";
import faviconOrlPng from "images/favicon_orl.png";
import faviconOrlIco from "images/favicon_orl.ico";
import mainMenuLogoBiblioboard from "images/logo-bb.png";
import mainMenuLogoOrl from "images/logo-orl.png";
import footerLogoBiblioboard from "images/logo-bb-horo.png";

export const FAVICON_OPTIONS = {
  ORL: {
    ico: faviconOrlIco,
    png: faviconOrlPng,
  },
  DEFAULT: {
    ico: faviconDefaultIco,
    png: faviconDefaultPng,
  },
};

export const MAIN_MENU_LOGO_OPTIONS = {
  ORL: mainMenuLogoOrl,
  DEFAULT: mainMenuLogoBiblioboard,
};

export const FOOTER_LOGO_OPTIONS = {
  ORL: mainMenuLogoOrl,
  DEFAULT: footerLogoBiblioboard,
};

export const getFaviconOption = faviconOptionName =>
  FAVICON_OPTIONS[faviconOptionName]
    ? FAVICON_OPTIONS[faviconOptionName]
    : FAVICON_OPTIONS.DEFAULT;

export const getMainMenuLogoOption = logoOptionName =>
  MAIN_MENU_LOGO_OPTIONS[logoOptionName]
    ? MAIN_MENU_LOGO_OPTIONS[logoOptionName]
    : MAIN_MENU_LOGO_OPTIONS.DEFAULT;

export const getFooterLogoOption = logoOptionName =>
  FOOTER_LOGO_OPTIONS[logoOptionName]
    ? FOOTER_LOGO_OPTIONS[logoOptionName]
    : FOOTER_LOGO_OPTIONS.DEFAULT;
